import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useViewModel } from "../react/useViewModel.js";
const formatTime = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime()))
        return value || "Pending time";
    return new Intl.DateTimeFormat("en-US", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
    }).format(date);
};
/** Staff notification bell bound to a NotificationViewModel. */
export function NotificationBell({ viewModel, onNotificationClick, pollMs = 15000, reloadEvents = [], classNames = {}, }) {
    const state = useViewModel(viewModel);
    const [open, setOpen] = useState(false);
    const c = classNames;
    const eventsKey = reloadEvents.join("|");
    useEffect(() => {
        const reload = () => void viewModel.load();
        reload();
        const id = pollMs > 0 ? window.setInterval(reload, pollMs) : undefined;
        const events = eventsKey ? eventsKey.split("|") : [];
        for (const e of events)
            window.addEventListener(e, reload);
        return () => {
            if (id !== undefined)
                window.clearInterval(id);
            for (const e of events)
                window.removeEventListener(e, reload);
        };
    }, [viewModel, pollMs, eventsKey]);
    const unread = viewModel.unreadCount;
    const openEntry = (entry) => {
        setOpen(false);
        void viewModel.markRead(entry.id);
        onNotificationClick?.(entry);
    };
    return (_jsxs("div", { className: c.root ?? "dlr-bell", "data-lumora-view": "notification-bell", children: [_jsxs("button", { type: "button", onClick: () => setOpen((v) => !v), className: c.button ?? "dlr-text-btn", "aria-label": "Notifications", children: [_jsx("svg", { width: "20", height: "20", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", "aria-hidden": "true", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M15 17h5l-1.4-1.4A2 2 0 0118 14.2V11a6 6 0 10-12 0v3.2c0 .5-.2 1-.6 1.4L4 17h5m6 0a3 3 0 11-6 0m6 0H9" }) }), unread > 0 ? _jsx("span", { className: c.badge ?? "dlr-num", children: unread }) : null] }), open ? (_jsxs("section", { className: c.panel ?? "dlr-bell-panel", children: [_jsxs("div", { className: c.head, children: [_jsx("h2", { className: c.title, children: "Notifications" }), _jsx("p", { className: c.subtitle, children: "Appointments and sale approvals" })] }), _jsxs("div", { className: c.list, children: [state.error ? (_jsx("p", { role: "alert", className: c.error, children: state.error })) : null, state.items.length === 0 ? _jsx("p", { className: c.empty, children: "No notifications." }) : null, state.items.map((item) => (_jsxs("article", { onClick: () => openEntry(item), className: [c.row, item.read ? c.rowRead : c.rowUnread].filter(Boolean).join(" "), children: [_jsxs("div", { children: [_jsx("p", { className: c.rowTitle, children: item.carTitle() }), _jsx("p", { className: c.rowTime, children: formatTime(item.createdAt) }), item.type === "sale_request" ? (_jsx("p", { className: c.rowSale, children: "Sale approval \u2022 Staff" })) : (_jsx("p", { className: c.rowStatus, children: "requested" }))] }), !item.read ? (_jsx("button", { type: "button", className: c.readButton, onClick: (event) => {
                                            event.stopPropagation();
                                            void viewModel.markRead(item.id);
                                        }, children: "Read" })) : null] }, item.id)))] })] })) : null] }));
}
//# sourceMappingURL=NotificationBell.js.map